import * as React from 'react';
import { ActualizationStatus } from '@websky/graphql';
import PriceChanged from '../PriceChanged/PriceChanged';
import FlightNotAvailable from '../FlightNotAvailable/FlightNotAvailable';
import ActualizationOk from './components/ActualizationOk/ActualizationOk';
import { ModalX } from '../../../../BaseComponents';
const Actualization = ({ actualizationInfo, open, showOkMessage, onClose, startBooking, backToResults }) => {
    const actualizationStatus = actualizationInfo === null || actualizationInfo === void 0 ? void 0 : actualizationInfo.status;
    const isOpen = actualizationStatus === ActualizationStatus.Success ? open && showOkMessage : open;
    const onStartBooking = () => {
        startBooking();
        onClose();
    };
    if (!actualizationStatus) {
        return null;
    }
    return (React.createElement(ModalX, { size: "medium", isOpen: isOpen, onClose: onClose, noPadding: true },
        actualizationStatus === ActualizationStatus.PriceIncreased && (React.createElement(PriceChanged, { newPrice: actualizationInfo.newPrice, oldPrice: actualizationInfo.oldPrice, onChangeFlight: backToResults, bookFlight: onStartBooking })),
        actualizationStatus === ActualizationStatus.Success && React.createElement(ActualizationOk, { onClick: onClose }),
        actualizationStatus === ActualizationStatus.NotAvailable && React.createElement(FlightNotAvailable, { onClick: backToResults })));
};
export default Actualization;
